import React, { useState } from "react";
import { BancosABM } from "./Bancos/BancosABM";
import { BancosListado } from "./Bancos/BancosListado";
import { type Banco } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type BancosView = "ABM" | "Listado";

export function BancosSection() {
  const [currentView, setCurrentView] = useState<BancosView>("Listado");
  const [selectedItem, setSelectedItem] = useState<Banco | null>(null);

  const handleEdit = (item: Banco) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <BancosABM
          banco={selectedItem}
          onBack={handleBack}
        />
      ) : (
        <BancosListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}